import { defineStore } from 'pinia';
import { cloneDeep, get, each, find, map } from 'lodash';
import Vue from 'vue';

import ProductApi from '@/extensions/shop/store/api/product';

export const useShopCategoryProductStore = defineStore('shopCategoryProduct', {
    state: () => ({
        loading: false,
        productsPaginated: {
            type: 'shop_category_product',
            variables: {
                paginationSizes: [25, 50, 100],
            },
            filters: {},
            pageInfo: {
                total: 0,
                perPage: 25,
                currentPage: 1,
                lastPage: 0,
                selection: {
                    type: 'inclusive',
                    identifiers: [],
                    total: 0,
                },
            },
            allColumns: [],
            activeColumns: [],
            showFilters: false,
            defaultSort: null,
            link: {},
            items: [],
        },
    }),

    actions: {
        addPaginatedProductsToState(data) {
            this.productsPaginated.items = data.items;
            this.productsPaginated.pageInfo = cloneDeep(data.pageInfo);
            if (data.config) {
                const isFirstLoad = !this.productsPaginated.allColumns.length;
                this.productsPaginated.allColumns = cloneDeep(data.config.allColumns);
                this.productsPaginated.link = cloneDeep(data.config.link);
                if (isFirstLoad) {
                    this.productsPaginated.showFilters = get(data.config, 'showFilters') || false;
                }
                this.productsPaginated.defaultSort = get(data.config, 'defaultSort') || null;
            }
        },

        defineActiveColumns(activeColumnKeys) {
            const activeColumns = [];
            each(this.productsPaginated.allColumns, column => {
                const allowed = find(activeColumnKeys, value => column.key === value);
                if (allowed) activeColumns.push(column);
            });

            if (activeColumns.length) {
                this.productsPaginated.activeColumns = activeColumns;
            }
        },

        defineItemsPerPage(perPage) {
            this.productsPaginated.pageInfo.perPage = perPage;
        },

        defineCurrentPage(currentPage) {
            this.productsPaginated.pageInfo.currentPage = currentPage;
        },

        defineFilterValue({ key, value }) {
            if (value.match === '' && value.like === '' && value.from === '' && value.to === '' && value.in.length === 0) {
                Vue.delete(this.productsPaginated.filters, key);
            } else {
                Vue.set(this.productsPaginated.filters, key, value);
            }
        },

        defineSorting({ key, value }) {
            Vue.set(this.productsPaginated.variables, 'order', key);
            Vue.set(this.productsPaginated.variables, 'direction', value);
        },

        defineFilterVisibility(value) {
            Vue.set(this.productsPaginated, 'showFilters', value);
        },

        updateLoading(value) {
            this.loading = value;
        },

        fetchProductsPaginated() {
            const paginatedData = {
                ...this.productsPaginated,
                scope: 'ex',
            };
            return ProductApi.fetchProductsPaginated(paginatedData).then(data => {
                this.addPaginatedProductsToState(data);
                const activeColumnKeys = map(get(data, 'config.activeColumnKeys') || [], 'key');
                this.defineActiveColumns(activeColumnKeys);
            });
        },
    },
});
